exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-payment .control-label[_v-063cdf20],label[_v-063cdf20]{font-size:12px}h2[_v-063cdf20]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-063cdf20&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Shopping-cart/Shopping-cart-summary.vue
// module id = 400
// module chunks = 0